import { inject } from '@angular/core';

import { createTracker, Events, TrackingEvent, withName } from '@manakincubber/tiime-tracking';
import { Store } from '@ngrx/store';
import { first, switchMap, tap } from 'rxjs/operators';

import { BusinessUser } from '@models/business-user';
import { businessUserSelector } from '@modules/core/store/business-user/business-user-selector';

import { APP_OPEN_IDENTIFIED } from '../events/app-open-identified';
import { USER_LOG_OUT } from '../events/user-log-out';
import { prefixBusinessUserId } from '../id-prefix';
import { AMPLI } from '../token';

export class InternalTrackingGroup {
  private readonly events$ = inject<Events<TrackingEvent>>(Events);
  private readonly ampli = inject(AMPLI);
  private readonly store = inject(Store);

  handleUserIdentification$ = createTracker(
    this.events$.pipe(
      withName(APP_OPEN_IDENTIFIED),
      switchMap(() => this.store.select(businessUserSelector).pipe(first(user => !!user))),
      tap((businessUser: BusinessUser) => {
        const amplitudeUserId = prefixBusinessUserId(businessUser.id);
        this.ampli.identify(amplitudeUserId, {
          initiales_collaborateur: businessUser.acronym,
          partner: businessUser?.partner?.name,
          type_d_utilisateur: 'collaborateur',
          business_unit: businessUser?.businessUnits?.map(bu => bu.name)
        });
      })
    )
  );

  handleUserLogOut$ = createTracker(
    this.events$.pipe(
      withName(USER_LOG_OUT),
      tap(() => {
        this.ampli.client.reset();
      })
    )
  );
}
